// extracted by mini-css-extract-plugin
module.exports = {"selectBox":"BaseAssetsList_selectBox__y62dl"};